import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';

import InfoImg from 'assets/img/info.svg';

const CollapsibleContent = ({ messages, showNumber, trigger }) => {
  return (
    <Collapsible
      className="subCollapsible"
      openedClassName="subCollapsible"
      transitionTime={ 100 }
      trigger={ trigger }
    >
      <table className="errorTable">
        <tbody>
          <tr>
            <th className="dateHeader">Date</th>
            <th className="typeHeader">Type</th>
            <th className="nameHeader">Name{ showNumber ? '/Number' : '' }</th>
            <th className="messageHeader">Message</th>
            <th className="retryHeader">
              Retry
              <img
                alt=""
                className="retryHeaderIcon"
                src={ InfoImg }
                title="This action will reset the specified conflict error. Be sure to sync again to get an updated log."
              />
            </th>
          </tr>

          { messages }
        </tbody>
      </table>
    </Collapsible>
  );
};

CollapsibleContent.defaultProps = {
  showNumber: false,
};

CollapsibleContent.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showNumber: PropTypes.bool,
  trigger: PropTypes.string.isRequired,
};

export default CollapsibleContent;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/components/CollapsibleContent.js